<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      mode="vertical"
    >
      <sidebar-item
        v-for="route in routes"
        :key="route.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from "vuex";
import variables from "@/styles/variables.scss";
import SidebarItem from "./SidebarItem";
import t from "../../../../utils/type";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["sidebar", "auths"]),
    routes() {
      let routes = this.$router.options.routes;
      let filterAuth = rs => {
        let nroutes = [];
        nroutes = rs.filter(v => {
          if (!t.isNullorUndefined(v.children)) {
            v.children = filterAuth(v.children);
          }
          if (v.meta && !t.isNullorUndefined(v.meta.guard)) {
            if (this.auths.includes(v.meta.guard)) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });

        return nroutes;
      };

      let froutes = filterAuth(routes);

      return froutes;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
